<template>
  <div>
      <h1 class="system-title">システムについて</h1>
      <div class="system-container" v-for="content in contentsWithIndex" :key="content.textTitle">
        <div class="system-img-content">
          <img class="system-img" :src=content.imgPath :alt=content.imgTitle>
          <div class="system-img-number">{{ content.index }}</div>
        </div>
        <div class="system-content">
          <p class="text-title">{{ content.textTitle }}</p>
          <p class="text-content">{{ content.textContent }}</p>
        </div>
      </div>  
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
    // なし
  },
  data:function(){
    return{
//       contents:[
//         {
//           imgPath:require('./img/dummy.png'),
//           imgTitle:'予約',
//           textTitle:'予約',
//           textContent:`ホットペッパー、公式HPから購入！好きなメニューを購入！店舗の予約をして、店舗にGO!`,
//         },
//         {
//           imgPath:require('./img/dummy.png'),
//           imgTitle:'ご来店',
//           textTitle:'ご来店',
//           textContent:`お店でやりたい施術を伝えていざ施術！`,
//         },
//         {
//           imgPath:require('./img/dummy.png'),
//           imgTitle:'施術スタート',
//           textTitle:'施術スタート！',
//           textContent:`カードをセットして施術開始！
// 気になる部位を重点的に。施術時間が終わったら、ジェルを拭いて終了。`,
//         },
//         {
//           imgPath:require('./img/dummy.png'),
//           imgTitle:'次の予約を取って終了！',
//           textTitle:'次の予約を取って終了！',
//           textContent:`定期的に通う方が効率よく効果を実感していただけます。施術のたびに次の予約を取るのが楽でオススメ。
// 全部終わったら、あとはすっきりした心と体で帰るだけ！`,
//         },
        /*{
          imgPath:require('./img/dummy.png'),
          imgTitle:'次回の予約とって終了',
          textTitle:'次回の予約とって終了',
          textContent:`夏だと薄着でムダ毛が気になっていたけど、脱毛してから
薄着もでき、おしゃれが楽しくなりました。
ミュゼで一箇所からはじめた脱毛が、他のところも気にな
り始め他の箇所もお手入れを始めました！以前はムダ毛
がほんとにコンプレックスだったので、ミュゼに通い始め
て自分に自信をもつことができました！ありがとうござ
います！！`,
        },*/
      // ]
    }
  },
  computed:{
    contentsWithIndex:function(){
      return this.contents.map(function(content,index){
        
        return {
          index:String(index+1).padStart(2,'0'),
          imgPath:content.imgPath,
          imgTitle:content.imgTitle,
          textTitle:content.textTitle,
          textContent:content.textContent,
        }
      })
    }
  }
}
</script>

<style scoped>
  @import "../../css/style.css";

  .mg-t-150{
    margin-top: 150px;
  }

   /* PC表示 */
  @media screen and (min-width:821px){
    .system-title{
      color: var(--main-color);
      font-size: 2.5em;
      letter-spacing: 0.2em;
      text-align: center;
      margin: 50px 0;

    }

    .system-container{
      display: flex;
      justify-content: center;
      margin: 5em;
    }

    .system-img-content{
      position: relative;
    }

    .system-img-number{
      color: var(--main-color);
      font-size: 7em;
      font-weight: 600;
      position: absolute;
      top: -0.6em;
      left: -0.2em;
    }

    .text-title{
      color:black;
      font-size: 1.5rem;
      font-weight: 600;
      margin-bottom: 0.7rem;
    }

    .text-content{
      font-size:1rem;
      line-height: 1.5em;
    }

    .system-img{
      width: 30vw;
      margin-right:40px;
    }

    .system-content{
      width: 30vw;
      margin-left:40px
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .system-title{
      color: var(--main-color);
      font-size: 5vw;
      letter-spacing: 0.2em;
      text-align: center;
      margin: 2em 0 1em 0;

    }

    .system-container{
      display: flex;
      flex-wrap: wrap;
      width: 100vw;
      justify-content: center;
      margin: 6em auto;
    }

    .system-img-content{
      width: 80vw;
      position: relative;
    }

    .system-img-number{
      color: var(--main-color);
      font-size: 15vw;
      font-weight: 600;
      position: absolute;
      top: -0.6em;
      left: -0.2em;
    }

    .system-img{
      width: 100%;
    }

    .system-content{
      width: 80%;
      margin-top: 1em;
      /*margin-left:40px*/
    }

    .text-title{
      color:black;
      font-size: 5vw;
      font-weight: 600;
      margin-bottom: 0.7rem;
    }

    .text-content{
      /*width: 80vw;*/
      font-size: 3vw;
      line-height: 1.5em;
    }
  }
</style>